import React from 'react';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';

const Toast = ({ message, type = 'info', onClose }) => {
  const config = {
    success: {
      icon: CheckCircle,
      bgColor: 'bg-green-950/80',
      borderColor: 'border-green-800/40',
      iconColor: 'text-green-400'
    },
    error: {
      icon: XCircle,
      bgColor: 'bg-red-950/80',
      borderColor: 'border-red-800/40',
      iconColor: 'text-red-400'
    },
    warning: {
      icon: AlertCircle,
      bgColor: 'bg-yellow-950/80',
      borderColor: 'border-yellow-800/40',
      iconColor: 'text-yellow-400'
    },
    info: {
      icon: Info,
      bgColor: 'bg-blue-950/80',
      borderColor: 'border-blue-800/40',
      iconColor: 'text-blue-400'
    }
  };

  const { icon: Icon, bgColor, borderColor, iconColor } = config[type];

  return (
    <div className={`${bgColor} backdrop-blur-2xl border ${borderColor} rounded-2xl p-4 shadow-overlay flex items-center gap-3 min-w-[320px] max-w-md animate-slide-in`}>
      <div className={`p-1.5 rounded-lg bg-white/[0.06] ${iconColor}`}>
        <Icon className="w-4 h-4" />
      </div>
      <p className="text-white font-medium text-[13px] flex-1 leading-snug">{message}</p>
      <button
        onClick={onClose}
        className="p-1 hover:bg-white/[0.06] rounded-lg transition-all duration-200"
      >
        <X className="w-3.5 h-3.5 text-dark-400" />
      </button>
    </div>
  );
};

export default Toast;
